import { render, staticRenderFns } from "./PlanForm.vue?vue&type=template&id=199506a6&scoped=true&"
import script from "./PlanForm.vue?vue&type=script&lang=js&"
export * from "./PlanForm.vue?vue&type=script&lang=js&"
import style0 from "./PlanForm.vue?vue&type=style&index=0&id=199506a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199506a6",
  null
  
)

export default component.exports